export const getLinkTreeTypeMeta = (type) => {
  switch (type) {
    case "location":
      return {
        label: "Standort",
        color: "orange",
        icon: "map marker alternate",
      };

    case "custom":
      return {
        label: "Individuell",
        color: "blue",
        icon: "linkify",
      };

    default:
      return {
        label: "Unbekannt",
        color: "grey",
        icon: "question circle",
      };
  }
};

export const getLinkTreeStatus = (isActive) => {
  if (isActive === 1) {
    return {
      key: 'published',
      label: 'Aktiv',
      color: 'green',
    };
  }

  return {
    key: 'draft',
    label: 'Inaktiv',
    color: 'grey',
  };
};

export const getUpdatedAtColor = (date) => {
  const diffHours = (Date.now() - new Date(date)) / 36e5;

  if (diffHours < 24) return "green";
  if (diffHours < 168) return "teal";
  return "grey";
};

export const getLinktreeUpdatePayload = (formData) => {
  const {
    title,
    subtitle,
    isActive
  } = formData;

  return {
    title,
    subtitle,
    isActive,
  };
};